/*🤫
🤫
🤫
🤫
🤫
🤫*/

export * from "./globals/event-loader";
export const { eventLoader } = window.o_global;
